/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type IssuesEntryPointComponent = EntryPointComponent<
	{},
	{},
	{},
	{
		objectClassId?: string;
		dictionaryId?: string;
		objectAttributeId?: string;
	}
>;

export const issuesEntryPoint: EntryPoint<IssuesEntryPointComponent, EntryPointRouteParams> =
	createEntryPoint({
		root: JSResourceForInteraction<IssuesEntryPointComponent>(
			/* webpackChunkName: "async-issues-page" */ './IssuesPage.tsx',
		),
		getPreloadProps: ({
			context: {
				match: { params },
			},
		}: EntryPointRouteParams) => ({
			extraProps: {
				objectClassId: params?.objectClassId || undefined,
				dictionaryId: params?.dictionaryId || undefined,
				objectAttributeId: params?.objectAttributeId || undefined,
			},
		}),
	});
